/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_B1_DescInputs */

const en_pol_scenario_b1_desc = /** @type {(inputs: Pol_Scenario_B1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A subscription login code kept on Bystep's servers. Never offered.`)
};

const id_pol_scenario_b1_desc = /** @type {(inputs: Pol_Scenario_B1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode login langganan disimpan di server Bystep. Tidak pernah ditawarkan.`)
};

/**
* | output |
* | --- |
* | "A subscription login code kept on Bystep's servers. Never offered." |
*
* @param {Pol_Scenario_B1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_b1_desc = /** @type {((inputs?: Pol_Scenario_B1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_B1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_b1_desc(inputs)
	return en_pol_scenario_b1_desc(inputs)
});